import * as React from 'react';
import {
  RadioGroup as FluentRadioGroup,
  Radio,
  type RadioGroupProps as FluentRadioGroupProps,
} from '@fluentui/react-components';

export interface RadioGroupItem {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface RadioGroupProps extends Omit<FluentRadioGroupProps, 'value' | 'onChange'> {
  value?: string;
  onValueChange?: (value: string) => void;
  items?: RadioGroupItem[];
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  value,
  onValueChange,
  items,
  children,
  className,
  ...rest
}) => {
  const handleChange: FluentRadioGroupProps['onChange'] = (_ev, data) => {
    onValueChange?.(String(data.value));
  };

  return (
    <FluentRadioGroup
      value={value}
      onChange={handleChange}
      className={className}
      {...rest}
    >
      {items
        ? items.map((it) => (
            <Radio key={String(it.value)} value={String(it.value)} label={it.label as Exclude<React.ReactNode, boolean>} disabled={it.disabled} />
          ))
        : children}
    </FluentRadioGroup>
  );
};


